/* Base translations · W17.3, W17.4 and W17.7 review worksheets — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): w17_3, w17_4, w17_7. */
export const I18N_BASE_W17_REVIEW = {
  en: {
    // Batch E · Round E2 — W17.3 – W17.7 dictionary (EN)
    w17_3: {
      title: "Inquiry and analytical procedures",
      subtitle: "ISRE 2400 (Revised); per FS head.",
      coverageTitle: "Areas where material misstatements are likely — coverage",
      noLikelyAreas: "No likely-misstatement areas yet — add them on 502(r).",
      pickHead: "— pick FS head —",
      rowsTitle: "Rows by FS head",
      runBtn: "Recompute",
      runQueued: "Recompute queued.",
      cyBalance: "CY balance",
      expectationPh: "Expectation",
      actualPh: "Actual",
      thresholdPh: "Threshold",
      diffPh: "Difference",
      plannedInquiriesPh: "Planned inquiries",
      explanationPh: "Explanation",
      corroborationPh: "Corroboration",
      conclusionPh: "Conclusion",
      diffAboveThreshold: "Difference above threshold without explanation — a W17.7 register entry has been created.",
      save: "Save",
      rowSaved: "Row saved.",
      notForAudit: "This page belongs to a Review engagement (ISRE 2400 Revised).",
    },
    w17_4: {
      title: "Required inquiries",
      subtitle: "ISRE 2400 (Revised) — the nine required topics.",
      allAnswered: "All nine inquiries answered.",
      pending: "Answers pending — W17 cannot be completed until every inquiry is answered.",
      responseRequired: "Response cannot be empty.",
      followupReq: "Follow-up required (→ W17.7)",
      askedOfPh: "Asked of",
      pickDate: "— pick a date —",
      responsePh: "Response",
      linkedRegister: "Follow-up linked to W17.7 register.",
      save: "Save",
      saved: "Inquiry saved.",
      notForAudit: "This page belongs to a Review engagement (ISRE 2400 Revised).",
      q: {
        a_accounting_estimates:         "(a) Accounting estimates.",
        b_related_parties:              "(b) Related parties and transactions with them.",
        c_significant_unusual_complex:  "(c) Significant, unusual or complex transactions.",
        d_fraud_or_noncompliance:       "(d) Actual, suspected or alleged fraud, or non-compliance with laws and regulations.",
        e_subsequent_events:            "(e) Subsequent events.",
        f_gc_basis_management:          "(f) The basis of management's going-concern assessment.",
        g_gc_events_conditions:         "(g) Events or conditions that may cast doubt on going concern.",
        h_commitments_obligations:      "(h) Material commitments, contractual obligations or contingencies.",
        i_nonmonetary_transactions:     "(i) Material non-monetary transactions or transactions for no consideration.",
      },
    },
    w17_7: {
      title: "Additional procedures register",
      subtitle: "ISRE 2400 (Revised) — matters from W17.3 / W17.4 / manual; outcome sends materially-misstated items to W9.",
      addManual: "Add a manual matter",
      fsHeadPh: "FS head",
      pickFsHead: "— FS head —",
      fsHeadRequired: "Pick an FS head, or choose \"Not specific to one FS head\".",
      matterPh: "Matter — what and why",
      matterRequired: "Matter cannot be empty.",
      add: "Add",
      registerTitle: "Register",
      empty: "No matters registered yet.",
      proceduresPh: "Procedures designed",
      pickOutcome: "— outcome —",
      pickPageForEnable: "— pick a greyed page —",
      enablePage: "Enable page (link + log)",
      pageEnabled: "Page enabled for this engagement.",
      linkedPages: "Linked pages",
      sentToW9: "Sent to W9 — misstatements bridge.",
      sentToW9Badge: "→ W9",
      notForAudit: "This page belongs to a Review engagement (ISRE 2400 Revised).",
      src: { manual: "Manual", w17_3: "W17.3", w17_4: "W17.4" },
      outcomeOpt: {
        Not_likely_materially_misstated: "Not likely materially misstated",
        Materially_misstated: "Materially misstated",
      },
    },
  },
  ar: {
    // Batch E · Round E2 — W17.3 – W17.7 dictionary (AR)
    w17_3: {
      title: "الاستفسار والإجراءات التحليلية",
      subtitle: "المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح) — لكل بند قوائم مالية.",
      coverageTitle: "المجالات التي يُرجَّح فيها وجود تحريفات جوهرية — التغطية",
      noLikelyAreas: "لا توجد بعد مجالات مرجّحة — أضفها في \u2066502(r)\u2069.",
      pickHead: "— اختر البند —",
      rowsTitle: "الصفوف حسب بند القوائم",
      runBtn: "إعادة الحساب",
      runQueued: "تمت إضافة إعادة الحساب إلى الطابور.",
      cyBalance: "رصيد السنة الحالية",
      expectationPh: "التوقع",
      actualPh: "الفعلي",
      thresholdPh: "العتبة",
      diffPh: "الفرق",
      plannedInquiriesPh: "الاستفسارات المخطط لها",
      explanationPh: "التفسير",
      corroborationPh: "التعزيز/التوثيق",
      conclusionPh: "الاستنتاج",
      diffAboveThreshold: "الفرق يتجاوز العتبة ولا يوجد تفسير — تم إنشاء إدخال في سجل \u2066W17.7\u2069.",
      save: "حفظ",
      rowSaved: "تم حفظ الصف.",
      notForAudit: "هذه الصفحة تخصّ ارتباط الفحص (\u2066ISRE 2400\u2069 المُنقّح).",
    },
    w17_4: {
      title: "الاستفسارات المطلوبة",
      subtitle: "المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح) — تسعة موضوعات مطلوبة.",
      allAnswered: "تمت الإجابة على الاستفسارات التسعة.",
      pending: "توجد إجابات ناقصة — لا يمكن إتمام \u2066W17\u2069 قبل الإجابة على جميع الاستفسارات.",
      responseRequired: "لا يمكن ترك الرد فارغًا.",
      followupReq: "يلزم متابعة (\u2190 \u2066W17.7\u2069)",
      askedOfPh: "الشخص المسؤول",
      pickDate: "— اختر التاريخ —",
      responsePh: "الرد",
      linkedRegister: "تم ربط المتابعة بسجل \u2066W17.7\u2069.",
      save: "حفظ",
      saved: "تم حفظ الاستفسار.",
      notForAudit: "هذه الصفحة تخصّ ارتباط الفحص (\u2066ISRE 2400\u2069 المُنقّح).",
      q: {
        a_accounting_estimates:         "(أ) التقديرات المحاسبية.",
        b_related_parties:              "(ب) الأطراف ذوو العلاقة والمعاملات معهم.",
        c_significant_unusual_complex:  "(ج) المعاملات الجوهرية أو غير المعتادة أو المعقّدة.",
        d_fraud_or_noncompliance:       "(د) الغش الفعلي أو المشتبه به أو المدعى، أو عدم الالتزام بالقوانين واللوائح.",
        e_subsequent_events:            "(هـ) الأحداث اللاحقة.",
        f_gc_basis_management:          "(و) أساس تقييم الإدارة لمبدأ الاستمرارية.",
        g_gc_events_conditions:         "(ز) الأحداث أو الظروف التي قد تُلقي بشك على الاستمرارية.",
        h_commitments_obligations:      "(ح) الالتزامات الجوهرية أو الالتزامات التعاقدية أو المطلوبات المحتملة.",
        i_nonmonetary_transactions:     "(ط) المعاملات غير النقدية الجوهرية أو المعاملات دون مقابل.",
      },
    },
    w17_7: {
      title: "سجل الإجراءات الإضافية",
      subtitle: "المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح) — المسائل من \u2066W17.3\u2069 / \u2066W17.4\u2069 أو يدويًا؛ الأثر «تحريف جوهري» يُرسل إلى \u2066W9\u2069.",
      addManual: "إضافة مسألة يدوية",
      fsHeadPh: "البند",
      pickFsHead: "— البند —",
      fsHeadRequired: "اختر البند أو «غير مرتبط ببند محدد».",
      matterPh: "المسألة — الوصف والسبب",
      matterRequired: "لا يمكن ترك المسألة فارغة.",
      add: "إضافة",
      registerTitle: "السجل",
      empty: "لا توجد مسائل مسجَّلة بعد.",
      proceduresPh: "الإجراءات المُصمَّمة",
      pickOutcome: "— النتيجة —",
      pickPageForEnable: "— اختر صفحة مُخفَّتة —",
      enablePage: "تفعيل الصفحة (ربط + تسجيل)",
      pageEnabled: "تم تفعيل الصفحة لهذه المهمة.",
      linkedPages: "الصفحات المرتبطة",
      sentToW9: "تم الإرسال إلى \u2066W9\u2069 — جسر التحريفات.",
      sentToW9Badge: "\u2192 \u2066W9\u2069",
      notForAudit: "هذه الصفحة تخصّ ارتباط الفحص (\u2066ISRE 2400\u2069 المُنقّح).",
      src: { manual: "يدوي", w17_3: "\u2066W17.3\u2069", w17_4: "\u2066W17.4\u2069" },
      outcomeOpt: {
        Not_likely_materially_misstated: "من غير المرجح أن يكون محرَّفًا جوهريًا",
        Materially_misstated: "محرَّف جوهريًا",
      },
    },
  },
};

export default I18N_BASE_W17_REVIEW;
